import React from "react";
import ImmediateSessionDot from "../ImmediateSessionDot";
// import moment from "moment";
import { filterList } from "../data";
import { useEffect, useState,useRef } from "react";
import { useSelector } from "react-redux";
import Search from "../../../../components/search";
// import Button from "../../../../components/button";
import { session_id_beg, session_id_end } from "../../../../utils/helpers";
import AppointmentInfoPanel from "../AppointmentInfoPanel";
import { useNavigate, useSearchParams } from "react-router-dom";
import Sorting from "../../../../components/sorting";
import Pagination from "../../../../components/tablePagination";
import Select from "react-select";
import Button from "../../../../components/button";

import { fireFilter } from "../functions";
import CsvDownload from "../../../../components/csvdownload";
import Filter from "../../../../components/filter";
import CopyComponent from "../../../../components/copyComponent";
import {ExportData} from "../../../../services/admin";
import { toast } from "react-toastify";

var apptAvatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function apptGetInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function apptGetAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % apptAvatarPalettes.length : 0;
  return Object.assign({}, apptAvatarPalettes[idx], {
    width: 36, height: 36, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '13px', flexShrink: 0,
  });
}

const headers = [
  { label: "Medium Name", key: "medium_name" },
  { label: "Client Name", key: "client_name" },
  { label: "Date", key: "date" },
  { label: "Time", key: "time" },
  { label: "Session Name", key: "session_type" },
  { label: "Emails", key: "emails" },
  { label: "Meeting Link", key: "meeting_link" },
  // { label: 'Feedback Links', key: "" },
  // { label: 'Date and Time Cancelled', key: 'date_time_canceled' },
  // { label: "Cancelled By", key: 'userby' },
  // { label: "No Show By", key: 'userby' },
];

export default function Ongoing(props) {
  const {
    showOngoingAppointments,
    // changeHandler,
    filterListAppointments,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    filterReset,
    ongoingAppointmentsPage,
    ongoingAppointmentsrowsPerPage,
    searchValue,
    serviceTypeList,
    changeHandlerFilter,
    serviceFilterValue,
    setSortingNameOrderBy,
    setSortingTabType,
    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    setServiceTypeShow,
    filterValues,
    serviceTypeShow,
    exportDownload,
    searchValueFilter
  } = props;

  const { allOngoingCount } = useSelector((state) => state.users);
  const [filterValuesMain, setFilterValuesMain] = useState({
    screen_name: ""
  });
   useEffect(() => {
         
          if (filterOprater && Object.keys(searchValue).length > 0) {
          const newValues = {
            filterValues: { ...searchValue },
            operator: filterOprater
          };
    
        console.log("NEW VALUES:", newValues);
          filtersRef.current = newValues; 
        }
      
        }, [])
  const [operatorVal,SetOperatorVal] = useState("=");
  const [filters, setFilters] = useState({ filterValues: { screen_name: ""}, operator: "" });
  const filtersRef = useRef({ filterValues: {}, operator: "" });
  const [isFilterDirty, setIsFilterDirty] = useState(true);
  const [panelAppointment, setPanelAppointment] = useState(null);
  const [panelViewType, setPanelViewType] = useState('appointment');
  const navigate = useNavigate();
  let info = JSON.parse(localStorage.getItem('pagination'))
  const navigateEdit = (e, id) => {
     window.renderFirst = false
    if (e.target.className == "capitalizeMedium") {
       navigate(`/profile-edit/${id.medium_id}`);
    } 
    if(e.target.className == "capitalize"){
      if(id.client_user_type == 3){
        navigate(`/edit/${id.client_id}`);
      }else{
        navigate(`/profile-edit/${id.client_id}`);
      }
    }
  };

  const handleSessionClick = (e, appoinment, columnType = 'appointment') => {
    if (e.target.closest && e.target.closest('button, a, input, select, textarea, [role="button"], .toggle-button-cover')) {
      return;
    }
    e.stopPropagation();
    if (columnType === 'medium' && !appoinment.medium_details) {
      columnType = 'appointment';
    }
    if (columnType === 'client' && !appoinment.client_details) {
      columnType = 'appointment';
    }
    setPanelViewType(columnType);
    setPanelAppointment(Object.assign({}, appoinment, {
      sessionIdDisplay: session_id_beg + appoinment.id + session_id_end,
    }));
  };
  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  // };

  const createString =() => {

    let string = `screen_name=${
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : ""}&session_type=${searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : ""}&session_id=${searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : ""}&name=${
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : ""}&medium_email=${
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : ""}&client_email=${
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : ""}&meeting_id=${
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          :""}&created_at=${searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : ''}&oprater=${filterOprater !== undefined ? filterOprater : ""}&country=${searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""}
      `
      return string;
  }
  const exportData =()=>{
          let info = {
                appoitment_type: "ongoing", appoitment_value: 0,queryString: createString()
            }
        ExportData(info).then((data) => {
                if (data.data.status) {
                    toast.success(data.data.message, { position: "top-center" });
                }
                }).catch(() => { })
          }

          const exportAllData = () => {
            let info = {
              appoitment_type: "ongoing", 
              appoitment_value: 0,
              queryString: "" 
            }
            ExportData(info).then((data) => {
              if (data.data.status) {
                toast.success("All data exported successfully", { position: "top-center" });
              }
            }).catch(() => { })
          }

          const fliterdata = (name, oprater) => {
  const newValues = {
    filterValues: { ...name },
    operator: oprater
  };
console.log("NEW VALUES:", newValues);
  filtersRef.current = newValues; // <--- instant update (no delay)
  setFilters(newValues);
  setIsFilterDirty(false);          // UI update (async, but that's fine)
};


const LoadData = () => {
  // optional: clear old UI result before new search
  console.log("FILTERS USED:", filtersRef.current.filterValues, filtersRef.current.operator);


// setUpcomingAppointments([]);
  filterListAppointments(
    filtersRef.current.filterValues,
    filtersRef.current.operator
  );
  setIsFilterDirty(true);
};
  return (
    <>
      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th className="min-width-100">Session #</th>
              <th>
                {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
                Medium Name
              </th>
              <th>Client Name</th>
              <th>
                <div className="d-inline-flex align-items-center align-items-center">
                  <span>Date &amp; Time</span>
                  <Sorting tab={7} callApi={filterListAppointments} view={'admin'} types={'date'} setSortingNameOrderBy={setSortingNameOrderBy} setSortingTabType={setSortingTabType} />
                </div>
              </th>
              <th>Session Name</th>
              {/* <th>Emails</th> */}
              <th>Meeting Link</th>
            </tr>
            {showOngoingAppointments.length > 0 ? (
              showOngoingAppointments.map((appoinment) => (
                <tr onClick={(e) => handleSessionClick(e, appoinment)} className="innr" style={{ cursor: 'pointer' }}>
                  {/* <td>{session_id_beg + appoinment.id + session_id_end}</td> */}
                  <td className="pointer" onClick={(e) => handleSessionClick(e, appoinment)}>


                    <div className="d-flex align-items-center">
                      <ImmediateSessionDot appointment={appoinment} /><div className="mr-1 mt-1"><CopyComponent value={session_id_beg + appoinment.id + session_id_end} /></div>
                      <div className="mt-1">{session_id_beg + appoinment.id + session_id_end}</div>
                      <div className="mr-1 mt-1 ml-1">
                        {appoinment.backfill_code !== null ? <>
                          ({appoinment.backfill_code})
                        </> : <></>
                        }
                      </div>
                    </div>
                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }}>
                    {/* <input type="checkbox" id="two" />
                    <label htmlFor="two"></label> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {appoinment.medium_profile_image ? (
                        <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                          <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.medium_profile_image} alt="" />
                        </div>
                      ) : (
                        <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.medium_name)}>{apptGetInitials(appoinment.medium_name)}</div>
                      )}
                      <span className="capitalizeMedium" style={{ display: 'block' }}>{appoinment.medium_name}</span>
                    </div>
                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span className="capitalize" style={{ display: 'block' }}>{appoinment.client_name} {appoinment.client_comment === true && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                    </div>
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td className="width-190px ">{appoinment.guest_booking == 1 ? (<b style={{
                          fontSize: '22px',
                        }}>*</b>) : ""}{appoinment.session_name}</td>
{/* Emails column hidden */}
                  <td className="googl-link">
                    <a
                      target={"_blank"}
                      className={`d-flex align-items-center justify-content-center resend-btn new-btn-click-here height-35 min-width-130px`}
                      href={appoinment.meeting_link}
                    >
                      Click Here
                    </a>
                    {/* <Button
                      className={`resend-btn w-unset height-35 min-width-130px`}
                      title="Click Here"
                      status={0}
                      onClick={() =>}
                    /> */}
                    {/* <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      src="images/copy.png"
                      alt="copy"
                    /> */}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* <div className="pagination-box">
          <div className="left-pagi">
            <span>Showing 1 to 10 of 18 entries</span>
          </div>
          <div className="right-pagi">
            <ul>
              <li>Previous</li>
              <li className="active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>Next</li>
            </ul>
          </div>
        </div> */}
                </div>
        <Pagination
          rowsPerPageOptions={[25, 50, 100]}
          count={allOngoingCount}
          activeTab={"ongoingAdmin"}
          getPaginationData={getPaginationData}
          ongoingAppointmentsPage={ongoingAppointmentsPage}
          ongoingAppointmentsrowsPerPage={ongoingAppointmentsrowsPerPage}
        />
        <AppointmentInfoPanel
          appointment={panelAppointment}
          viewType={panelViewType}
          onClose={() => setPanelAppointment(null)}
          onMediumClick={(appt) => navigateEdit({ target: { className: 'capitalizeMedium' } }, appt)}
          onClientClick={(appt) => navigateEdit({ target: { className: 'capitalize' } }, appt)}
        />
      </div>
    </>
  );
}
